module.exports = __webpack_public_path__ + "9b9f1349ad7d565fceb601c6e34cad3a.jpg";